export default __webpack_public_path__ + "static/media/opensans-semibold-webfont.91e39c8d.woff";